import { useState } from 'react';

import { useRouteMatch } from 'react-router-dom';

import Edit from 'components/Icons/Edit';
import useRouterHelper from 'hooks/useRouterHelper';

import IStudyQuery from '../../../../IURLQuery';
import Delete from './Delete';
import BinTrash from '../../../../../../../components/Icons/BinTrash';

const EditAndDeleteButtons = ({ callback }) => {
  const { query, routePush } = useRouterHelper<IStudyQuery>();
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  const { params } = useRouteMatch<{
    id: string;
  }>();
  const parentId = params.id;

  const handleEditButtonClick = () => {
    if (!query && query.type) {
      return;
    }
    switch (query?.type) {
      case 'structure':
        routePush({
          search: {
            edit: true,
          },
          removeSearch: ['newItem'],
        });
        break;
      default:
        routePush({
          path: '/study/form',
          search: {
            subject: parentId,
            item: query?.lesson,
            type: query?.type,
            title: query?.title,
          },
        });
    }
  };

  // edit and delete buttons are not required when nothing is selected
  if (query && !query.type) {
    return <></>;
  }

  return (
    <>
      <div
        className="btn p-0 nowrap text-small no-underline text-bold"
        onClick={() => {
          handleEditButtonClick();
        }}
      >
        <Edit fontSize={18} />
      </div>
      <div>
        <div className="cursor-pointer" onClick={() => setDeleteModal(true)}>
          <BinTrash fontSize={18} />
        </div>

        {deleteModal && (
          <Delete callback={callback} handleModal={() => setDeleteModal(false)} deleteModal />
        )}
      </div>
    </>
  );
};
export default EditAndDeleteButtons;
